import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetSession } from "../../EnvConfig/env_config";


export const getHeaderMenu = createAsyncThunk(
    'getHeader',
    async (data, thunkAPI) => {
        try {
            let res = await fetch('/api/UserLogin/GetMenu', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.json()
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    });


const initialState = {
    open: false,
    companyCode: '',
    branchCode: GetSession('cookies','branchCode'),
    unitName:'',
    menu:null,
    error: null,
    loading: false,
};


const headerSlice = createSlice({
    name: 'headerSlice',
    initialState,
    reducers: {
        setOpen: (state, action) => {
            state.open=action.payload
        },
        setCompanyCode: (state, action) => {
            state.companyCode = action.payload;
        },
        setActiveClass: (state, action) => {
            state.activeClass = action.payload
        },
        setBranchCode: (state, action) => {
            state.branchCode = action.payload;
        },
        setUnitName: (state, action) => {
            state.unitCode = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getHeaderMenu.fulfilled, (state, action) => {
            state.menu = action.payload;
            state.loading = false;
        })
            .addCase(getHeaderMenu.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getHeaderMenu.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false;
            })

    }
});

export const { setOpen, setCompanyCode, setActiveClass, setBranchCode, setUnitName } = headerSlice.actions

export default headerSlice.reducer
